const angel = {
  //美丽天使
  path: 'angel', //办公室
  component: () => import("@/views/member/angel/angel"),
  meta: {
    tabBar: 'home'
  },
  children:[
    { //招募收益
      path: 'recruit',
      component: () => import("@/views/member/angel/recruit"),
    },
    { //美丽天使商城收益
      path: 'angel-store',
      component: () => import("@/views/member/angel/angel-store"),
    },
    { //我的会员
      path:"angel-member",
      component: () => import("@/views/member/angel/angel-member"),
    },
    { //28元领皂 邀新用户统计
      path:"user-stat",
      component: () => import("@/views/member/angel/user-stat"),
    },
  ]
};

export default angel;